import { useOneOffPageDetail } from '@fs/zion-rootstech'
import useErrorHandlerOverlay from './useErrorHandlerOverlay'
import { brightspotConfig } from '../config'
import useDetailAugmentation from './useDetailAugmentation'

export default function useOneOffPageData({ path }) {
  // web-derived, bandwidth-aware image sizes injected into the shared hook
  const { loading, data, error } = useOneOffPageDetail(path, { imageSizes: brightspotConfig.imageSizes })
  useErrorHandlerOverlay(error)

  const { data: augmentedData, loading: augmentedLoading } = useDetailAugmentation({
    loading,
    data,
  })

  return { loading: augmentedLoading, data: augmentedData, error }
}
